/**
 * Minimum character limit for email messages.
 * This ensures emails are not flagged as spam by email systems.
 */
export const MESSAGE_MIN_CHARACTER_LIMIT = 50;
